import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const ClipboardIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        opacity="0.2"
        d="M20.0001 5C20.6506 5.86473 21.0016 6.91789 21 8V9H11V8C10.9984 6.91789 11.3494 5.86473 11.9999 5H7C6.86868 5 6.73864 5.02586 6.61731 5.07611C6.49598 5.12637 6.38574 5.20003 6.29288 5.29288C6.20003 5.38574 6.12637 5.49598 6.07611 5.61731C6.02586 5.73864 6 5.86868 6 6V27C6 27.1313 6.02586 27.2614 6.07611 27.3827C6.12637 27.504 6.20003 27.6143 6.29288 27.7071C6.38574 27.8 6.49598 27.8736 6.61731 27.9239C6.73864 27.9741 6.86868 28 7 28H25C25.1313 28 25.2614 27.9741 25.3827 27.9239C25.504 27.8736 25.6143 27.8 25.7071 27.7071C25.8 27.6143 25.8736 27.504 25.9239 27.3827C25.9741 27.2614 26 27.1313 26 27V6C26 5.86868 25.9741 5.73864 25.9239 5.61731C25.8736 5.49598 25.8 5.38574 25.7071 5.29288C25.6143 5.20003 25.504 5.12637 25.3827 5.07611C25.2614 5.02586 25.1313 5 25 5H20.0001Z"
        fill="#2E2E2E"
      />
      <path
        d="M12 19H20"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 15H20"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0002 5H25C25.2652 5 25.5196 5.10536 25.7071 5.29289C25.8946 5.48043 26 5.73478 26 6V27C26 27.2652 25.8946 27.5196 25.7071 27.7071C25.5196 27.8946 25.2652 28 25 28H7C6.73478 28 6.48043 27.8946 6.29289 27.7071C6.10536 27.5196 6 27.2652 6 27V6C6 5.73478 6.10536 5.48043 6.29289 5.29289C6.48043 5.10536 6.73478 5 7 5H11.9997"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 9V8C11 6.67392 11.5268 5.40215 12.4645 4.46447C13.4021 3.52678 14.6739 3 16 3C17.3261 3 18.5979 3.52678 19.5355 4.46447C20.4732 5.40215 21 6.67392 21 8V9H11Z"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ClipboardIcon;
